<template>
    <div>

        <div v-if="inactivity_notice" class="inactivity-notice pos-absolute">
            <div class="notice">
                <p>There has been no activity for several minutes.<br/>Do you wish to remain on the page?</p>
                <button @click="countdown = idle_time, inactivity_notice = false, inactivity_body_class()">Yes</button>
            </div>
        </div>
        <div class="map-component pos-relative" :class="{'fullscreen' : fullscreen}">

            <button type="button" v-if="!options.fullscreen" class="fullscreen-toggle pos-absolute" @click="fullscreen = !fullscreen" aria-label="Fullscreen map toggle">
                <svg v-show="fullscreen !== true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25" style="enable-background:new 0 0 25 25" xml:space="preserve">
                    <path d="M25 .6c-.1-.3-.3-.5-.6-.6h-6.7c-.6 0-1 .5-1 1s.5 1 1 1h3.8l-7.3 7.3c-.4.4-.4 1.1 0 1.5.2.2.5.3.7.3s.5-.1.7-.3l7.3-7.3v3.8c0 .6.5 1 1 1 .6 0 1-.5 1-1V1c.1-.1.1-.2.1-.4zM.7.1C.4.2.2.4.1.6.1.8 0 .9 0 1v6.3c0 .6.5 1 1 1s1-.5 1-1V3.6l7.3 7.3c.4.4 1.1.4 1.5 0 .2-.2.3-.5.3-.7 0-.3-.1-.5-.3-.7L3.6 2.1h3.8c.6 0 1-.5 1-1s-.5-1-1-1H1.1C1 0 .8 0 .7.1zM.1 24.4c.1.3.3.5.6.6h6.7c.6 0 1-.5 1-1s-.5-1-1-1H3.6l7.3-7.3c.4-.4.4-1.1 0-1.5-.2-.2-.5-.3-.7-.3-.3 0-.5.1-.7.3l-7.3 7.3v-3.8c0-.6-.5-1-1-1s-1 .5-1 1V24c-.2.1-.1.2-.1.4zM24.4 24.9c.3-.1.5-.3.6-.6v-6.6c0-.6-.5-1-1-1-.6 0-1 .5-1 1v3.8l-7.3-7.3c-.4-.4-1.1-.4-1.5 0-.2.2-.3.5-.3.7 0 .3.1.5.3.7l7.3 7.3h-3.8c-.6 0-1 .5-1 1s.5 1 1 1H24c.1.1.3.1.4 0z"/>
                </svg>
                <svg v-show="fullscreen === true" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 25 25" style="enable-background:new 0 0 25 25" xml:space="preserve">
                    <path d="M13.9 10.5c.1.3.3.5.6.6.1.1.3.1.4.1h6.3c.6 0 1-.5 1-1 0-.6-.5-1-1-1h-3.8l7.3-7.3c.4-.4.4-1.1 0-1.5-.2-.3-.5-.4-.7-.4-.3 0-.5.1-.7.3L16 7.6V3.9c0-.6-.5-1-1-1-.6 0-1 .5-1 1v6.3c-.2.1-.2.2-.1.3zM10.5 11.1c.3-.1.5-.3.6-.6.1-.1.1-.3.1-.4V3.9c0-.6-.5-1-1-1-.6 0-1 .5-1 1v3.8L1.8.3C1.4-.1.7-.1.3.3.1.5 0 .8 0 1s.1.5.3.7L7.6 9H3.9c-.6 0-1 .5-1 1 0 .6.5 1 1 1h6.3c.1.2.2.2.3.1zM11.1 14.5c-.1-.3-.3-.5-.6-.6-.1-.1-.3-.1-.4-.1H3.9c-.6 0-1 .5-1 1s.5 1 1 1h3.8L.4 23.1c-.4.4-.4 1.1 0 1.5.1.3.4.4.6.4s.5-.1.7-.3L9 17.4v3.8c0 .6.5 1 1 1 .6 0 1-.5 1-1v-6.3c.2-.2.2-.3.1-.4zM14.5 13.9c-.3.1-.5.3-.6.6-.1.1-.1.3-.1.4v6.3c0 .6.5 1 1 1 .6 0 1-.5 1-1v-3.8l7.3 7.3c.4.4 1.1.4 1.5 0 .2-.2.3-.5.3-.7 0-.3-.1-.5-.3-.7L17.3 16h3.8c.6 0 1-.5 1-1 0-.6-.5-1-1-1h-6.3c-.1-.2-.2-.2-.3-.1z"/>
                </svg>
            </button>

            <div class="map pos-relative">

                <div class="markers time-periods" v-if="type == 'time_periods'">
                    <ul v-for="(value, index) in map_themes" :key="index" :style="{ '--item-total': map_events.length, 'top': coordinates_array[index][0] + '%', 'left': coordinates_array[index][1] + '%' }" class="marker theme-marker pos-absolute" :class="[check_current_theme(value.slug) ? 'disabled' : '', theme == value.slug && map_events.length > 0 ? 'active' : '']" :aria-label="value.title + ' map marker'">
                        <button type="button" class="theme-pin" :value="value" @click="set_current_theme(value.slug), side_panel = false">
                            <svg class="pin" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35 35">
                                <path :style="{ 'fill': marker_colour(value,'theme') }" d="M0 17.5 17.5 35 35 17.5 17.5 0 0 17.5Z"/>
                                <path fill="#ffffff" transform="rotate(-45 17.5 17.502)"  d="M10.83 10.83h13.35v13.35H10.83z"/>
                                <path :style="{ 'fill': marker_colour(value,'theme') }" transform="rotate(-45 17.5 17.502)" d="M15.14 15.14h4.73v4.73h-4.73z"/>
                            </svg>
                            <span class="tooltip">
                                {{ value.title }}
                            </span>
                        </button>
                        <span v-if="theme == value.slug">
                            <li v-for="(value, index) in map_events" :key="index" :style="{ '--item-count': index + 1 }" class="marker event-marker pos-absolute" :aria-label="value.title + ' map marker'">
                                <button type="button" class="event-pin" :value="value" @click="selected_event = value, show_event_in_side_panel()">
                                    <svg class="pin" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35 35">
                                        <path :style="{ 'fill': marker_colour(value,'event') }" d="M0 17.5 17.5 35 35 17.5 17.5 0 0 17.5Z"/>
                                        <path fill="#ffffff" transform="rotate(-45 17.5 17.502)"  d="M10.83 10.83h13.35v13.35H10.83z"/>
                                        <path :style="{ 'fill': marker_colour(value,'event') }" transform="rotate(-45 17.5 17.502)" d="M15.14 15.14h4.73v4.73h-4.73z"/>
                                    </svg>
                                    <span class="tooltip">
                                        {{ value.title }}
                                    </span>
                                </button>
                            </li>
                        </span>
                    </ul>
                </div>
                    
                <div class="markers themes" v-if="type == 'themes'">
                    <div v-for="(value, index) in map_events" :key="index" :style="{ 'top': coordinates_array[index][0] + '%', 'left': coordinates_array[index][1] + '%' }" :aria-label="value.title + ' map marker'" class="marker event-marker pos-absolute">
                        <button type="button" class="event-pin" :value="value" @click="selected_event = value, show_event_in_side_panel()">
                            <svg class="pin" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35 35">
                                <path :style="{ 'fill': marker_colour(value,'event') }" d="M0 17.5 17.5 35 35 17.5 17.5 0 0 17.5Z"/>
                                <path fill="#ffffff" transform="rotate(-45 17.5 17.502)"  d="M10.83 10.83h13.35v13.35H10.83z"/>
                                <path :style="{ 'fill': marker_colour(value,'event') }" transform="rotate(-45 17.5 17.502)" d="M15.14 15.14h4.73v4.73h-4.73z"/>
                            </svg>
                            <span class="tooltip">
                                {{ value.title }}
                            </span>
                        </button>
                    </div>
                </div>

                <div class="map-container pos-absolute">
                    <img :src="holding_map" class="holding-map pos-absolute" id="holding-map"/>
                    <img v-if="type == 'time_periods'" :src="map" class="main-map pos-absolute" alt="Historic map of Chatham Historic Dockyard"/>
                    <img v-if="type == 'themes'" :src="options.theme_map" class="main-map pos-absolute" alt="Historic map of Chatham Historic Dockyard"/>
                </div>
                
            </div>
            
            <div class="map-shadow pos-absolute">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1600 900"><path d="M1594.4 865c1.7-3.1 2.7-6.6-.6-10.1-2.2-2.4-4.3-6-.4-9.3.1-.1 0-.4 0-.6 1.7-4.3 2-8.1-2.7-11.1-2.4-1.6-1.9-3.4-.4-5.9 2-3.3 4.9-6.5 3.4-11-.1-.2 0-1 .1-1.6.9-3.7 2.5-7.3 3.2-11 1.1-5.1 2.3-10.4-1.6-15.2-.5-.6-.8-1.8-1.1-2.8-1-3.3.1-6.6-.3-9.8-.3-2.4-.1-4.7.5-6.9.7-2.6 1.4-5.1-.6-7.6-.8-1-.6-2.4 0-3.4 1-1.7 1.3-3.6 2.8-5.1 1.3-1.4 1.6-3.3.1-5-2.2-2.3-1.7-4.8-1-7.6.7-2.7 1.3-5.6.2-8.5-1-2.7-3.1-4.5-5.1-6.3-1.5-1.3-3.4-2.5-2.7-4.4 1.9-5.1 1.6-10.6 3.2-15.8 1.1-3.4 4.6-7.1 1.3-11.3-.1-.1.3-.7.3-.9-.6-2.2 0-4.4-.5-6.6-.3-1.3-.4-2.6 1.1-3.8 2.4-1.9 2.7-4.5 1.4-7.5-1.5-3.6-1.9-7.4-.6-11.3 1.3-4 1.4-8.3-.7-11.9-1.9-3.2-3.4-6.2-4.3-9.9-.6-2.8-1.4-5.7-3-8.2-1.3-2-1.2-3.5.9-5.4 3.2-3 5.8-6.9 5.4-11.5-.3-3.9-1.5-7.8-2.3-11.8 2.9-2.3 3.9-6.3 7.2-8.4.3-.2.7-.8.6-1.2-.5-3.7.4-7.7-2.1-11-.6-.8-1.4-1.4-1.3-2.5.4-4-1-7.7-1.1-11.7 0-.9-.1-1.7.6-2.6 1.4-1.9.6-3.1-1.4-4.5-3.2-2.2-4.9-3.4-2.9-8.4.6-1.5 1.1-3.1 2-4.4 1.7-2.4 1.6-4.9.6-7.2-1.7-3.9-1.3-7.3 1-10.8 1.5-2.2 2.6-4.8 2.9-7.5.5-3.4-1.7-5.7-3.4-8.2-.7-.9-1.6-1.9-1.1-2.8 1-2.1-.1-3.6-.9-5.4-1.8-3.8-2.8-7.6 0-11.7 1.5-2.1 1.6-5 .7-7.5-.9-2.4-.6-4.6-.6-7 0-2.7 1-5 1.4-7.5.7-4.7 1.3-9.4 1.6-14.1.2-3.1.1-6.2-2.7-8.5-2.4-2-3.6-5-4.8-7.5 3.8-3.4 6.1-7 4.3-12-.8-2.2-1.4-4.2-.3-6.7.5-1.3.2-2.9-.7-4.4-.6-1-1.6-2-1.3-3.4.7-3.7-1.4-6.4-3.5-9.3 3.2-1.7 4.7-4.2 2.7-7.7-3.4-5.9-.1-10.5 3-15.1 1.7-2.6 3.8-4.9 5.4-7.5 1.1-1.7 1-2.6-.5-4.2-4.1-4.4-6.5-9.8-2-15.9-2.7-2.3-3.5-5.3-2.7-8.9.1-.7.4-1.5-.2-2.2-.7-.8-.2-1.4.3-2.2 2.3-3.7 2-7.7 1-11.6-1.2-4.6-1.8-9-.1-13.5.2-.4.3-.9.3-1.3-.6-7.9-.5-15.8-2-23.6-.3-1.5-.8-3.8.7-4.6 2.8-1.5 1.9-3.2.9-5.1-.9-1.7-1.9-3.3-.4-5.4.8-1.2.3-3-.8-4.3-1.3-1.4-1.1-3-.6-4.7.5-1.5 1.1-2.9 2.2-4.1 2.7-3 2.6-3.3-.2-6.3-1.1-1.1-2.2-2.1-2.2-4.1 3.1-2.1 3.6-5.6 3.1-9.1-.4-3.2-.7-6.3-.8-9.5-.1-3.1 0-6.4-3.7-7.4.9-3.9 2-7.3 3.6-10.5 1.3-2.7 2-5.1-1.5-6.7-.4-.2-.5-1-.8-1.7 1.7-1.4 3.3-3 3-5.4-.5-4.4.3-9.2-3.7-12.6l-.6-.6c-1.2-1.3-1-2.6.4-3.4 2.6-1.7 2.8-4.3 3.6-6.9.8-2.7.3-4.4-2-5.7-1.9-1.1-1.7-2.6-.6-4.1 2-2.6 2.3-5.3 2.1-8.5-.1-2.3-1.5-4.2-1.3-6.3.3-4-1.3-8.1.6-12 .1-.3.1-.7 0-.9-1.2-3.4-2.2-6.8-4.3-9.8-1.5-2.2-3.6-3.8-5.1-6l-.6-.6c-1.3-4.1-1-4.6 3.2-6.3 3.3-1.4 6.1-3.6 6.3-7.5.2-2.9 1.5-4.7 3.8-6.3 1.2-.8 2.9-1.2 3.3-3.2-1.3-1.6-2.8-3.1-3.8-5-1.3-2.7-3.7-5.6-2.7-8.4 2-5.2 2-10.3 1.4-15.5-.3-2.5-.4-4.8 1.8-6.4-.9-1-1.1-2-2-2.8-3-2.5-3.9-6.1-4.3-9.8-.1-1.2 0-2.4 1.3-3.1 2.6-1.6 3.9-4.2 5.1-6.9 1.7-3.9 2.9-7.9.2-12-.8-1.2-1.1-2.8-1-4.4.4-4.9.5-9.9 1.2-14.8.1-.6.1-1.1.2-1.7-3.1-.2-6.1-.5-9.1-1.1-7.1-1.3-14.4.7-19.9 4.3-9.7 6.4-18.1 3-26.7-1.2-2.2-1.1-4.4-2.1-6.2-4.6-2.8-3.9-8-1.9-11.6-.7-5.1 1.8-9.4 1.3-13.6-1.5-2.2-1.4-4.5-1.7-7.1-1.7-4 0-7.9.3-11.5-2.7-1.9-1.6-5.1-1.2-6.9.5-4.8 4.5-10.2 4.9-16.4 4.2-8.6-1-17 .9-25 4-3.4 1.4-6.3.4-9.2-.8-.9-.4-1.9-1.2-2.6-1.7-6.2-5.1-13.5-6.5-21.2-6.6-3.5-.1-6.8-.7-9.2-3.8-1.9-2.4-5.6-2.7-7.4-1.6-5.4 3.4-12.3 2.8-17.1 7.6-2.3 2.3-5.4-.4-8-1.1-9.9-2.5-19.4-3.7-27.7 4.1-2.6 2.5-6.3 2.5-9.2 1.9-5-1-9 .5-12.5 3.4-2.8 2.3-6.1 4-8.8 6.4-3.5 3.2-7.3 2.9-10.9.9-4.5-2.5-9.7-.6-14.2-3.2-3.9-2.2-7.9-4.7-10.5-8-2.4-3.2-4-2.3-6.8-1.6-4.6 1.1-9.1 3.7-14.1 1.2-.8-.4-2.1-.8-2.5-1.3-3.2-3.6-7-2.4-9.8-.4-8 5.8-15.6 4-23.4.1-4.4-2.2-8.7-2-13-.1-6.5 2.9-13.3 5.1-19.7 8.4-3.6 1.8-7.7 1.7-11.3-.1-5.8-2.8-11.4-2.5-17.4-.7-9.2 2.8-18.6 5.2-27.2 9.6-3.6 1.8-6.8 1.4-9.8-1.2-2.1-1.8-4.3-3.6-6.4-5.5-5.4-4.8-11.5-6.2-18.4-4-4.4 1.5-8.7 1.6-13-.1-1.9-.7-3.6-1-5.5.9-5.6 5.7-12.1 6.3-19.5 3.2-7.9-3.2-16.3-2.7-24.3-.8-7.5 1.8-10.3 1.3-15.2-4-2.5-2.7-3.6-7.5-8-7.6-6.5-.2-13.3-1.5-19.5 1.8-.7.4-1.5.6-2.2 1.1-4.5 3.1-8.4 2.9-13.1-.5-4.9-3.5-10.4-6.5-17.2-4.3-3.1 1-7 .7-10.2-.1-5.2-1.2-9.8-.3-14.1 2.2-2.8 1.6-5.9 2-8.8 3-1.5.5-3.8 1-5.4-1-4.3-5.3-9.7-2.2-14.6-1.7-5.2.6-10.1 4.3-15.8 1.6-1.1-.5-3.2 1.2-4.8 2-4.8 2.2-9.4 5.4-14.8.5-2.3-2-6.6-1.6-9-.5-3 1.4-5.5.3-7.1-.6-5.9-3.2-11.2-2.9-17-.1-.8.4-1.7 1.5-2.6 1.1-5.9-2.2-9.4 2.4-13.6 4.8-2.8 1.6-5.2 2.1-8.7 1.8-11.6-1.2-23.2.1-34.7 2.1-4.7.8-9.8.4-13.6 4.2-.9-1.3-2.6-.2-3.9-1.6-4.7-4.8-10.6-2.8-16.1-1.9-8.3 1.4-15.5-.3-21.6-6.2-1.7-1.6-3.6-2.8-5.9-2.7-3.4.1-6.6-.9-9.7-1.8-3.8-1.1-7.1-2-10.5 1.4-2.1 2.1-7.6.5-9.6-2.2-.9-1.3-1.5-2.8-2.8-3.8-3.2.1-3.9 2.1-3.8 4.9.1 1.9.5 3.9-2.2 4.9-2.7 1.1-5.3 1.5-7.6-.2-2.3-1.8-4.3-4-6.4-6.1-8.3 7.8-10.4 8.8-19.6-1.8-4.7.2-8.1 3.3-11.9 5.4-5.4 3-10.5 2.9-14.6-1.4-2.9-3.1-5.9-2.6-8.7-1.5-5.1 2.1-9.8 3-13.5-1.2-2.1-.6-2.7.6-3.4 1.4-2.9 3.6-6.6 4.3-10.3 1.9-2.3-1.5-4.4-.5-6.6-1-1-.2-1.6.4-2.2 1.1-5.4-5.3-11.6.1-17.4-1.2-1.6-.4-3.3 0-4.9-1.1-2.9-2.2-5.3-1.3-8.8 0-4.8 1.9-8.6 4.9-12.9 7.4-1.9 1.1-3.7 1.1-5.5.8-11.8-1.7-23.4-4.1-34.7-7.8-2.8-.9-4.6-3.1-7-4.4-2.8-1.4-5.7-2.1-8.1.9-1.8 2.1-3.9 3.8-6.5 4.8-5.1 2-9.9 4.9-15.8 1.6-4.1-2.3-9-2.1-12.9.4-5.4 3.5-10.2 1.9-14.6-1-3.1-2-5.3-3.8-9.4-2.3-3.4 1.3-6.9-2-10.2-1.8-3.5.2-5.8 5-9.8 5-6.2-.1-12 1-18.1 2.7-3.8 1.1-8.8-2.4-13.4-2.3-5.8.1-11.5-1.1-17.4-.5-6.2.6-12.3 2-18.4 2.9-5.7.9-11.7 1.9-16.4 6.1-5.4 4.8-12.1 6.3-18.9 4.5-4.1-1.1-7.3.9-10.2 2-3.8 1.5-6.7 1.2-9.9-.5-5.1-2.6-10.3-4.5-16.3-4-4.7.4-7.9-2.8-10.8-6-4.1-4.5-5.9-5-10.8-2.2-4 2.3-8.2 2.6-12.5 3-4.5.4-9.1-1.5-13.6.8-1.9 1-4.5.2-6.4-1.1-4.9-3.3-10.3-5.3-16.2-4.4-6.8 1-12.6-1.7-17.2-5.8-5.9-4.4-11.2-3.7-16.4-1.1-5 2.5-9.4 3.3-13.6-.9-2.1-2-4.2-1.3-5.9 0-2.7 2.1-5.9 3-8.8 4.7-3.6 2.1-7.1 3.6-11.5 1.7-2.2-1-5.1-.4-7 1.5-5.3 5.2-10.8 3.3-16.3.8-2.1-.9-4.2-2-5.9 0-5.4 6.6-10.6 3-15.8-.2-.9-.6-1.7-1.3-3.1-1.8-3.7 6-9 2.2-13.1.9-6-1.9-11.3 1-16.9.7-2.2-.1-1.9 2.7-3.3 3.7-7.3-1.8-15.2-1.2-22-6.7-.5 1.6-1.3 2.7-2.2 3.4.3.5.7.9 1.1 1.3 4.5 3.6 4.7 5.9 1.2 10.4-3.4 4.3-3.7 10.7-.8 15.3 1.5 2.3 1.4 3.1-1 6.1 1.1 3.9 2.6 7.8.5 11.7-.7 1.2.1 1.9.7 2.6.8 1 1.5 1.9 2 3.2.9 2.4.6 4.3-1.4 5.9-2.5 1.8-2.4 4.3-1.6 6.8.9 3 1.1 6.2 2.1 9.2.3.9.6 2.4-.3 3.2-1.8 1.7-1 3.4-.4 5.2.9 3 1.4 6-.7 8.7-.8 1-.1 2 .1 2.6 1.5 3.4 2.4 6.4.7 10.2-1 2.3-.6 5.5.5 8 1.4 3.3 0 5.5-2.4 7.5.4.2.3.6.4.7 2.9 2.6 3.4 4.7 1.2 8.6-1.9 3.3-1.5 8-.1 12.2 1.7 5.2 2.7 10.7 2.6 16.2 0 1.6-.3 3.1-.7 4.5-.8 2.4-.5 4.6.1 7.2 1 4.3 1.4 8.8.7 13.3-.2 1.5-1.1 3.3-2.6 3.8-3.4 1.1-2.3 3.4-1.9 5.6.1.8.6 1.5.9 2.3 1 2.3 1.1 4.3-1.8 5.3 1 2 2.9 2.6 4.3 3.8 2.4 2.1 2.8 4.4 1.3 7.5-1.3 2.6-2.8 5-4.3 7.4-2.1 3.4-2.4 6.6-.1 10.1 2.1 3.2 2.7 6.6.3 10.1-.7 1-.3 2.2 0 3.2 1 3.7 1.5 7.4-.8 10.7-1 1.5-.4 2.6 0 3.9 1.1 3.5 3.3 6.9.7 10.8-.9 1.3.9 3.1 1.6 4.4 1.7 3 2 5.9.4 8.8-1.3 2.6-.5 6.1-3.5 7.9 4.7 5 4.4 8.1.4 12.2-.8.9-.8 1.8-.6 2.6.4 1.7 1 3.4 1.9 4.9 1.3 1.9 1.6 3.6.6 5.6-.5 1.1-.3 2.1-.1 3.3 1.3 5.4 1.3 10.6-.7 15.9-1.5 3.8.2 7.8.2 11.7 0 4.6 2 9.1.3 13.7-.4 1.1.2 2 1.3 2.3 1.8.5 1.8 1.8 1.9 3.3.3 3.2.8 6.3-1.3 9.1-.4.5-.1 1.5.5 2.3 1.4 1.8 3.6 2.5 5.3 3.9-.9 2.7-2.2 5.2-4 7.5-2.7 3.5-4.4 7.7-1.4 11.9 1.5 2.1 1.5 3.6-.4 5.3-3.9 3.4-3.5 8.7-5.6 13-.7 1.5.7 3 .6 4.5-.1 1.6.5 3.4-.7 4.9-1 1.2.3 2 .7 2.9 1.3 2.8 2.6 5.5 1.3 8.8-.7 1.8.5 3.7 1.6 5.1 2.8 4 3.1 7.9 1.7 12.8-2.1 6.9-2.8 14.1.3 21.1 1.9 4.1 1.9 8-1.3 11.7-2.7 3.1-2.2 5.1 1.2 7.4 1.3.9 2.3 1.8 2.7 3.6.6 2.2 2 4.3 4.1 5.6 4.3 2.7 4.2 8.5 3.1 12.4-.6 2.5-2.1 4.7-1.1 7.5.5 1.5-.7 2.4-1.9 2.9-4.4 1.5-4.4 5.3-4.2 8.8.2 2.6.2 4.8-1.7 6.9-1.6 1.8-1.1 4.2 0 6.1 1.7 2.9 3.6 5.7 5.8 8.1 1.6 1.8 1.8 3.3.9 5.3-1.5 3.4-2.5 6.9-4.4 10.2-1.1 2-1.4 5.2-.9 8 .4 2.2 0 4.2-.6 6.5 1.7 1.7 2.8 3.8 3.2 6.5.4 2.3 1.8 4.3 3.2 6.2 1.3 1.6 1.2 3.2-.1 4.2-3 2.3-.7 4.3.1 6.2.6 1.6 3.2 2.2 2.8 4.6-.4 2.9-1.8 5.4-3.3 7.8-.7 1-1.5 1.9-2.3 2.8-.2 1.3.6 2.3 1 3.3.7 1.7.9 3.3-.2 4.6-3.5 3.8-1.9 7.9.5 10.6 3.2 3.5 1.7 6.8 1.3 10.2-.2 1.7-.8 3.8-2.5 4.8-1.9 1.3-1.5 3-.9 4.5 1.6 4.1 1.1 7.9-2.1 10.7-1.5 1.3-2.2 2.3-1.4 4.6 1 3-.7 6.2-.3 9.4-3.4 3.1-1.1 6.3 0 9.4.7 2.1 1.1 4-.1 5.9-1.8 2.8-.7 5.1 1.3 7.2.6.7 1.2 1.5 2 1.9 1.9 1.1 2.2 3.4 1.4 4.5-2.5 3.5-2.1 8-4.5 11.4-.3 1.4 1.9 1.5 1.6 2.9 0 .2.1.5 0 .6-5.9 4.8-4.7 10.7-1.3 15.6 2.2 3 3.3 6.1 2.5 9.8-.5 2.4-.3 4.8 1.1 7.2 1.2 2 1.7 4.5 0 6.4-2.7 3-1.4 6 .1 8.4 1.6 2.6 2.6 4.6.5 7.3-.3.4-.2 1.4.2 2.2 1.6 3.1 1.6 6.3.2 9.4-1.1 2.4 2 3.4 1.3 5.2-.7 1.8-1.9 3.2-.7 5.3.8 1.3.7 3.1 1.4 4.5.9 1.9.4 3.5-.8 4.9-1.6 1.8-1.5 3.6-1 5.6.6 2.5.2 5 .9 7.5.1.5-.1 1.5-.3 1.9-1.7 2.6-2.8 5 .6 7.3.8.5.5 1.8-.2 2.9-1.1 1.6-1 3.3-.2 5.2.7 1.6 1.4 3.3 1 5.2-.1.3-.2.8 0 1 4.6 4.8 1.8 10.4 1.4 15.6-.1.9.1 2-.4 2.9.4-.1.8-.1 1.2-.2 4-.8 8.1-.9 11.7.5 3.5 1.4 5.2.2 8-1.5 4.8-2.8 7.3-8.8 13.4-9.5 2.3 2 3 5.2 5.5 6.9l1.1 1.1c3 1.5 5.8 1.7 8.4-.9 2.3-2.3 5.5-3.2 8.1-5.2 2.3-1.8 6.2-3 8.7.1 1.8 2.2 4.1 2.2 6.2 2.8 5.3 1.3 10.6 2 15.6 4.7 2.5 1.3 6.2.7 8.4-2.9 2.3-3.6 5.3-2.9 7.1 1.2 2.6 5.9 5.3 7.7 11 6.9 4.1-.5 8.2-1.6 11.8-3.7 3.4-2 6.4-3.9 10.7-2.1 2.1.8 4.8.4 7.3-.6 2.1-.9 4.6-1.3 7.3.5 5.7 3.7 6.6 3.6 12.2-.8 5.8-4.5 12.1-4.8 18.5-2.3 8.7 3.5 17 4.1 25.2-1.1 1.7-1.1 2.9-2.7 4.5-3.9 5.8-4.2 7.9-4.4 13.9-.2 2.8 2 5.9 2.2 8.9 1.7 4.3-.7 8.2-2.6 11.3-5.8 1.6-1.6 3.1-3.8 5.7-3.7 4.3.2 7.7-1.4 11.3-3.6 4.1-2.5 8.4-3.2 11.7 2.3 1.7 2.8 3.8 5.4 5.9 8 6 7.2 9.3 7.6 16.7 2.1.2-.2.4-.4.6-.5 3.7.7 7.6 1.8 11.2-.3 6.6-4 13.2-2.7 20.2-.8 3.6 1 7.7 2.9 11.7.4 2.1-1.3 4.2-2.5 6.2-3.8 3.8-2.5 6.8-2.3 10.7.6 5.3 3.9 11.6 7 18.7 6.2 5.8-.7 10.7-3.4 15.2-6.9l.6-1.1c1.9-2.2 5-4.2 7.2-3 4.3 2.4 8.6 3.5 13.4 3.5 2.8 0 4.9 2.4 7.2 4 7.6 5.2 8 5.2 15.6-.2 1.3-.9 2.6-.8 3.9.1 6.3 3.9 14 5.1 19.4 10.9 3.7 3.9 10.6 3.5 14.9-.2 3.2-2.7 6.3-5.6 8.7-9.2 3.3-5.1 4.6-5.3 9.5-2 3 2 6.4 1.9 9.4.7 4.8-1.9 8.9-1.8 13.5.9 5.5 3.3 11.6 5.2 17.7 1.5 3.3-1.9 5.8-1.7 9 .1 4.8 2.7 9.9 2.7 14.5-1.2 3.5-2.9 7.7-4.7 11.8-6.5 2.5-1.1 5.6-1.1 7.1.8 4.2 5.4 11 7.5 15.5 12.5 2.8 3.1 6.2 2.9 10 1.5 3.2-1.2 4.2-4 6.3-6.1 1.7-1.7 3.4-5.7 6-3.6 3.2 2.6 6.5 1.8 9 .9 4.7-1.7 7.9.1 11.2 2.7 2.4 1.9 5.1 2.4 8.3 2.6 10.4.7 20-4 30.3-3.6 3 .1 5.5-.1 8.4 1.8 6.8 4.6 14.1 7.9 21.7.7 3.6-3.4 8.2-2.7 12.2-.3 3.2 1.9 6.5 3.7 9.4 6.2 2.8 2.4 7 3.4 9.8 1.3 6-4.6 13.2-5.7 19.9-7.5 5.1-1.4 11 1.6 16.2-1.5.7-.4 1 .8 1.6 1.1 3.7 2 7.2 2.2 11.2.4 3.3-1.6 7-2.3 10.5-3.4 5.7 7.5 5.6 7.3 15.1 4.5 2.5-.7 5.9-3.1 8.2-.4 3.4 3.9 7 3.7 11.2 2.4 7.6-2.3 14.3-2.5 21.9 2.3 10.4 6.5 21.9 4.4 32.2-2.3 7.5-4.9 7.4-4.9 13.4.9 1.8-.2 2.6-2.3 4-2.6 2.5-.6 5.4-2.9 7.8.1 4.4 5.5 9.9 4.2 15 1.9 7.2-3.3 13.7-4.5 19 2.4 4.8-1.8 9.4-4.5 13.4-2.5 7.7 3.8 15.8 2.5 23.5 2.1 4.1-.2 6.8 0 9.4 2.9 8.9-5.1 10.9-5 17.3.4l.6-1.7c2-1.1 4.1-2.2 6.2-3.4 2.1 4.5 5.9 5.7 9.9 4.2 9.1-3.4 18.2-2.6 27.4-1.6 1.4.1 2.6.2 4-.9 1.9-1.5 4.4-2.3 6.7-3.3 6.2-2.6 12.3-3.1 17.8 1.5 1.7 1.5 3.3 1.3 5.1.6 9.7-3.8 19.3-7.6 27.3-14.9 5.2-4.7 6.6-4.2 12.1.2 3.3 2.7 6.6 6 8.6 9.7 3.2 5.8 6.8 5.5 12.4 3.8 6.7-2 14.4-5.9 20.4 2.4 4.2-3.3 8.6-5.2 13-7 1.5.3 2.4 1.5 2.8 2.4 2.7 5.9 7.4 6.2 12.8 4.7 7.3-1.9 15-1.2 22.4-2.8 3.6-.8 7.6.2 9.9 2.6 6.1 6.2 12.7 5.2 20.2 4 4.3-.7 8.7-3.7 13.4-1.2.7.4 1.8.3 2.8-.4 2.8-1.8 6.3-2.3 9-4.3 3.2-2.4 6-2.3 8.4 1.3.5.7 1 1.7 2.6 1.8 7.2-2.6 15.3-2.7 23.2-4.4 4.4-.9 9.1 0 13.4 2.8 14.2 9.3 29 6.3 42.8-.4 5.7-2.8 10.8-4.1 16.4-2.5 5.2 1.5 10.8.5 15.7 3.5 1 .6 2.6.3 3.4-1.5.7-1.4 2.3-2.2 4.8-3.1 1 1.2 2.5 2.7 3.4 4.4 3.5 7.3 9.9 9.7 17.1 11 1.4.2 2.9.9 3.9 1 5.7.2 12.1 2.3 16.3-3.9 1.2-1.8 3.2-2.2 5.1-2.1 3.3.3 5.9-.9 8.4-2.7.6-.4 1.1-.5 1.9-.5.8 1.2 1.7 2.6 2.5 3.9 5.3-1.5 9.9-4.3 14.7-6.9 2.9-1.6 5.4-2.4 9.1-.1 4.5 2.8 10.2 4.9 14.9-.5l2.3-2.2c5.9-3.2 10.6-2.4 14.5 2.6 5.7 7.1 5.6 7.1 13.4 1.5.7-.5 1.6-1.8 2.7-1.1 5.2 3.1 11.2 1.6 16.7 3.1 6.6 1.9 8.4 1.2 12.4-4.2 1-1.3 1.9-2.5 2.9-3.8 2.9-4.1 8.1-6.6 11.7-5.5 2.1.6 4.3 1 6.4 1.3-.4-1.5-.9-3-1.4-4.5-.4-3.6-.3-6.1 1.3-9.2z"/></svg>
            </div>

            <div class="map-controls pos-absolute">
                <div class="torn-edge pos-absolute"></div>            
                <div class="shadow pos-absolute">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1917.46 436.51"><path d="M1915.88 436.39c-636.96 0-1273.91 0-1910.87.13-4.44 0-5.02-1.19-5.01-5.2C.12 311.75.1 192.2.1 72.64c2.09-3.44 5.63-5.05 8.95-6.87 2.4-1.32 4.76-.71 7 .82 3.54 2.42 7.11 2.16 10.72-.06 3.56-2.19 7.37-3.74 11.65-3.89 1.5-.05 3.04-.39 4.31-1.12 4.77-2.72 9.62-4.37 15.13-2.35 1.35.49 2.54-.45 3.65-1.2 1.44-.62 2.86-.59 4.28.04 1.57 1.13 3.32 1.46 5.2 1.1 7.52-1.44 14.81-.33 22.01 1.9 1.37.49 2.44 1.26 2.72 2.79 6.84 1.37 10.44-.1 14.01-5.68 2.05-3.19 4.84-5.5 8.57-6.42 4.03-.99 8.83-1.38 11.79-3.59 4.63-3.46 8.25-1.73 12.86-1.11 12.29 1.66 24.28 5.88 36.93 4.78 1.59-.14 2.84.81 3.95 1.86 2.8 2.68 5.94 2.66 8.41.03 3.74-3.98 8.38-4.35 13.25-4.39 9.31-.08 18.56 1.3 27.89 1.02 4.5-.13 8.96-.27 13.36-1.3 1.62-.38 3.34-.89 4.93-.37 5.25 1.71 9.69-.82 14.32-2.46.91-.46 1.86-.59 2.85-.37 1.38.51 2.56 1.41 4.09 1.72 7.57 1.53 15.22 2.36 22.1 6.79 4 2.57 9.6 1.36 14.21 3.43 1.84.83 2.49-.95 2.22-2.72.15-1.51 1.09-2.12 2.49-2.24 6.35 1.27 12.79 1.86 19.24 2.35 4.94.38 9.34 5.27 10.25 10.81.66-2.27 2.98-2.96 5.42-3.49 1.25-.13 2.48-.06 3.64.45.4.21.7.53.89.89-.04.32-.1.57-.18.69.16-.18.39-.36.72-.56 3.4-1.52 7.24.29 10.7-1.77 1.35-.8 2.72 1.43 3.86 2.6.3.61.37 1.26.29 1.91 1.81 1.39 3.62.22 5.43.04 6.97-.69 13.98-1.65 20.39 2.42 1.31.83 2.81.98 4.32 1.04 15.27.57 30.31-.31 44.47-6.87 2.72-1.26 5.65-2.16 7.95-4.14 5.01-4.31 11.18-4.67 17.28-5.28 1.14-.11 2.46.42 3.46-.13 5.95-3.27 12.68-1.97 18.95-3.33 5.27-1.14 10.39-1.2 15.64.97 4.41 1.82 9.3 3.04 13.8-.45.78-.61 2.19-1.19 2.79-.53 5 5.51 10.53 1.97 15.17.17 5.52-2.14 11.15-3.28 16.82-4.35 6.77-1.28 13.26-3.19 19.38-6.35.74-.38 1.49-.84 2.31-.92 8.83-.82 17.17-4.86 25.97-4.86 9.52 0 17.91-3.07 26.33-6.64 4.53-1.92 9.23-.76 13.85-.88 4.53-.12 8.98-.04 12.88-2.95 1.79-1.34 4.07-1.34 6.25-1.36 5.33-.05 10.77.66 15.97-.16 11.72-1.84 23.52-3.51 34.67-7.98 3.46-1.39 6.58-3.15 9.06-6 1.4-1.6 3.36-2.04 5.43-2.13 8.37-.35 16.66-.04 24.56 3.13 2.24.9 4.24.79 6.16-.5 4.22-2.85 8.8-2.77 13.46-1.69 4.62 1.06 9.13 1.12 13.81-.06 6.81-1.71 13.8-2.2 20.84-1.56 1.17.11 2.38.12 3.4.7 5.29 3.01 11.11 3.3 16.96 3.23 3.52-.04 6.4 1.05 9.06 3.42 4.95 4.42 11.3 4.58 16.71.58 3.9-2.89 8.34-2.22 12.53-1.71 5.21.63 10.13.53 15.29-.77 5.92-1.48 12.09-.9 17.46 2.28 5.87 3.48 12.12 4.5 18.71 4.13 3.25-.18 6.13.62 9.19 1.68 7.29 2.53 14.73 4.88 22.53 1.82.31-.12.65-.21.98-.19 10.84.71 21.11-2.06 31.38-4.94 2.07-.58 4.35-.52 6.46-.09 3.65.74 6.45.89 8.5-3.38 1.52-3.16 9.02-3.46 13.32 0 5.49 4.41 10.67 3.48 16.32 1.35 1.72-.65 3.53-1.11 5.37-1.07 2.98.06 5.1-1.05 7.42-3.15 5.29-4.8 12-3.62 18.01-1.97 6.47 1.77 12.48 1.65 18.4-1.14 5.78-2.72 12.25-3.11 18.07-5.71 2.58-1.15 4.45.64 5.65 2.86 3.66 6.8 9.45 9.42 16.98 9.04 6.52-.33 13.02-.24 18.94 3.21 1.01.59 2.24.71 3.4.69 11.45-.22 23 1.3 34.23-2.37 3.06-1 6.3-.74 9.33.45 3.25 1.27 6.25.82 8.98-1.19 9.31-6.86 20.29-7.77 31.22-8.75 3.18-.28 6.24-.8 9.3-1.69 6.43-1.86 12.43-2.54 18.14 2.79 3.8 3.55 9.1 2.35 13.07-.31 5.07-3.4 9.46-3.28 14.21.2 8.67 6.35 18.43 10.91 26.81 17.99 6.09 5.14 14.51 7.99 22.61 9.87 15.2 3.53 30.67 3 46.09 1.92 6.18-.43 12.22-.74 18.01 2.16 9.67 4.84 20.03 5.67 30.64 4.97 3.05-.2 6.05-.79 8.65-2.24 8.22-4.59 17.08-3.6 25.83-3.12 4.5.25 8.97.57 13.45.03 7.65-.91 15.17-1.18 22.73 1.22 6.84 2.17 14.48.97 21.13 3.21 9.11 3.07 19.18 1.77 27.78 6.93 3.08 1.85 7.35-.36 10.75 1.38 8.28 4.24 17.55 5.07 26.27 7.8 4.97 1.56 10.06 2 15.28 1.1 4.35-.75 8.63-.49 12.4 2.34 4.67 3.51 10.21 2.9 15.43 2.55 7.53-.5 14.04 2.35 20.37 5.49 10.11 5 20.7 7.08 31.85 6.83 2.4-.05 4.68.25 6.79 1.3 5.19 2.58 10.61 2.79 16.08 1.45 2.89-.71 5.1-.08 7.44 1.59 5.98 4.27 12.53 6.85 20.08 6.13 5.33-.5 10.09.69 14.49 4.08 6.26 4.81 12.59 1.97 18.71-.76 1.02-.45 1.76-1.77 2.93-1.79 8.65-.14 16.32-4.55 24.75-5.54 2.76-.32 5.22-.96 6.75-3.57.89-1.51 2.33-2.57 4-2.75 7.77-.83 15.15-4.01 23.12-3.7 4.87.19 9.68-.47 14.16-2.49 7.58-3.42 15.67-3.99 23.79-4.47 1.5-.09 3-.14 4.47-.45 14.67-3.16 29.67-3.55 44.54-5.02 4.35-.43 9.36-.98 13.02 2.98.95 2.95.39 5.97.39 8.94.03 118.54.04 237.07 0 355.61 0 3.08.84 6.38-1.41 9.15Z"/></svg>
                    </div>
                <div class="content-container" :class="type">
                    <div class="toggle-buttons pos-absolute">
                        <button type="button" aria-label="Show centuries" @click="set_inital_map(), change_map_type('time_periods'), side_panel = false" :class="{'active' : type == 'time_periods'}">Centuries</button>
                        <button type="button" aria-label="Show themes" @click="change_map_type('themes')" :class="{'active' : type == 'themes'}">Themes</button>
                    </div>
                    <div class="main-buttons">
                        <div v-if="type == 'time_periods'" class="time-periods">
                            <button type="button" v-for="item in time_periods" :value="item.slug" :key="item.id" :class="set_active_button_class(item.slug,time_period)" @click="set_current_time_period(item.slug),randomise_coordinates_array()" :aria-label="'Select ' + item.title + ' century'">
                                {{ item.title }}s
                            </button>
                        </div>
                        <div v-if="type == 'themes'" class="themes">
                            <button type="button" v-for="item in themes" :value="item.slug" :key="item.id" :class="[check_current_theme(item.slug) ? 'disabled' : '', set_active_button_class(item.slug,theme)]" @click="set_current_theme(item.slug),randomise_coordinates_array()" :aria-label="'Select ' + item.title + ' theme'">
                                <img :src="item.icon"/><p>{{ item.title }}</p>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="side-panel-container pos-absolute" :class="{ 'hidden': !side_panel }">
                
                <button type="button" class="panel-toggle-button pos-absolute" :disabled="theme.length == 0" @click="side_panel = !side_panel" aria-label="Show or hide side panel">
                    <svg v-show="!side_panel" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.41 24">
                        <path d="M0 12.15 13.67 0l1.74 1.96L3.94 12.15l11.14 9.89L13.34 24 0 12.15z"/>
                    </svg>
                    <svg v-show="side_panel" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.41 24">
                        <path d="M15.41 11.85 1.74 24 0 22.04l11.47-10.19L.34 1.96 2.08 0l13.33 11.85z"/>
                    </svg>
                </button>
                
                <div class="shadow pos-absolute"></div>

                <div class="side-panel">

                    <div class="event-details-outer-container" v-if="side_panel && selected_event !== null">
                        <div class="event-details-inner-container">

                            <a :href="selected_event.image" target="_blank" class="event-image">
                                <div class="outer-container">
                                    <div class="inner-container">
                                        <img :src="selected_event.image"/>
                                    </div>
                                </div>
                            </a>
                            <div class="event-details pos-relative">
                                <h3>{{ selected_event.title }}</h3>
                                
                                <div class="event_time_period pos-absolute">
                                    {{ selected_event.time_periods[0] }}
                                </div>

                                <div class="event_text" v-html="selected_event.description"></div>

                                <div class="event-audio-container">
                                    
                                    <audio v-if="!changing_event" ref="audio" controls :src="selected_event.sound" type="audio/wav" id="audio-player" style="display:none;" @timeupdate="audio_time($event.target.currentTime)"></audio>

                                    <div class="audio-controls">
                                        <button type="button" aria-label="Pause audio recording" v-if="audio.playing" @click="audio_pause()" class="audio-button">
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45.6 50">
                                                <path d="M33.1 38.8c0 1.2-.9 2.1-2.1 2.1h-3c-1.2 0-2.1-.9-2.1-2.1V11.3c0-1.2.9-2.1 2.1-2.1h3c1.2 0 2.1.9 2.1 2.1v27.5zM19.7 38.8c0 1.2-.9 2.1-2.1 2.1h-3c-1.2 0-2.1-.9-2.1-2.1V11.3c0-1.2.9-2.1 2.1-2.1h3c1.2 0 2.1.9 2.1 2.1v27.5z"/>
                                            </svg>
                                        </button>
                                        <button type="button" aria-label="Continue playing audio recording" v-if="!audio.playing" @click="audio_play()" class="audio-button">
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45.6 50">
                                                <path d="M0 32V4.4C0 .5 2.7-1.1 6.1.8l12.4 6.9c3.4 1.9 8.9 5 12.2 6.9l12.4 6.9c3.4 1.9 3.4 5 0 6.9l-12.4 6.9c-3.4 1.9-8.9 5-12.2 6.9l-12.4 7c-3.4 1.9-6.1.3-6.1-3.6V32z"/>
                                            </svg>
                                        </button>
                                        <p class="audio-time">{{ time }} / {{ audio.duration }}</p>
                                    </div>
                                
                                    <template v-if="!changing_event">
                                        <waveform :audio_file="selected_event.waveform_sound" />
                                    </template>

                                </div>

                                <div v-if="map_events.length > 0" class="event-navigation">

                                    <button type="button" aria-label="Navigate to previous event" v-if="previous_event" @click="audio_pause(),selected_event = previous_event" class="next-event" :title="previous_event.title">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 173.58 48.6">
                                            <path style="fill:#77493f" d="M173.58 20.24H48.66c.17-3.93.59-7.55 1.2-10.64.92-4.73 2.28-8.2 3.85-9.6L0 24.3l53.71 24.3c-1.57-1.4-2.93-4.86-3.85-9.59-.62-3.18-1.04-6.92-1.21-10.98h124.93v-7.79Z"/>
                                        </svg>
                                        <span>{{ previous_event.title}}</span>
                                    </button>
                                    <span v-else></span>
                                    
                                    <button type="button" aria-label="Navigate to next event" v-if="next_event" @click="audio_pause(),selected_event = next_event" class="previous-event" :title="next_event.title">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 173.58 48.6">
                                            <path style="fill:#77493f" d="M0 28.36h124.92c-.17 3.93-.59 7.55-1.2 10.64-.92 4.73-2.28 8.2-3.85 9.6l53.71-24.3L119.87 0c1.57 1.4 2.93 4.86 3.85 9.59.62 3.18 1.04 6.92 1.21 10.98H0v7.79Z"/>
                                        </svg>
                                        <span>{{ next_event.title}}</span>
                                    </button>
                                    <span v-else></span>

                                </div>
                            </div>
                            
                        </div>
                    </div>

                </div>

            </div>

        </div>
    
    </div>
</template>

<script>
import waveform from "./waveform";

export default {
    props: {
        events: Array,
        themes: Array,
        time_periods: Array,
        options: Array
    },
    components: {
        waveform
    },
    data() {
        return {
            /* Toggles */
            fullscreen: false,
            side_panel: false,
            /* Map type settings */
            type: '',
            time_period: '',
            theme: '',
            /* Background maps */
            map: null,
            holding_map: null,
            show_holding_map: false,
            fade_holding_map: false,
            map_themes: [],
            map_events: [],
            selected_event: null,
            /* Marker coordinates */
            time_period_marker_positions: [
                // Simplified coordinates for the theme markers on the time periods map
                // Having fewer reduces the likelihood of overlap
                [
                    [15,15],[38,15],[61,15],[26.5,38],[49.5,38],[15,61],[38,61],[61,61]
                ],
                [
                    [26.5,15],[49.5,15],[15,38],[38,38],[61,38],[26.5,61],[49.5,61]
                ]
            ],
            theme_marker_positions: [
                // For event markers within the theme section we need more coordinates (20 in this case)
                [22,23.75],
                [36,23.75],
                [50,23.75],
                [64,23.75],
                [78,23.75],
                [22,41.25],
                [36,41.25],
                [50,41.25],
                [64,41.25],
                [78,41.25],
                [22,58.75],
                [36,58.75],
                [50,58.75],
                [64,58.75],
                [78,58.75],
                [22,76.25],
                [36,76.25],
                [50,76.25],
                [64,76.25],
                [78,76.25]
            ],            
            coordinates_array: [],
            /* Function processing state */
            changing_values: false,
            changing_event: false,
            audio_interval: null, // Our audio interval
            audio: {
                duration: 0,
                remaining: 0,
                playing: false,
                one: 0,
                two: 0
            },
            time: 0,
            /* Inactivity */
            idle_time: 0, // Starts at zero and counts up in every 10 seconds
            total_time: 300, // This is the total time we compare with for inactivity (represented as seconds)
            inactivity_time: 280, // Display our notice within the last 4 minutes 40 seconds (280 seconds)
            inactivity_notice: false // Finally our visibility toggle for the notice
        }
    },
    computed: {
        current_theme() {
            // Used by: Side panel
            // Returns the selected theme for display on side panel

            if(this.theme.length > 0) {
                var results = this.themes.filter(e => e.slug === this.theme);
                // console.log(results)
                return results[0];
            }
            return false;       
        },
        previous_event() {
            // Used by: Side panel
            // Returns the previous event

            if(this.map_events.length > 2) {
                var index = this.map_events.map(object => object.title).indexOf(this.selected_event.title);
                if(index > 0) {
                    var previous_post_index = (index - 1);
                    return this.map_events[previous_post_index];
                } else {
                    var previous_post_index = (this.map_events.length - 1);
                    return this.map_events[previous_post_index];
                }
            }
            return false;
        },
        next_event() {
            // Used by: Side panel
            // Returns the next event

            if(this.map_events.length > 2) {
                var index = this.map_events.map(object => object.title).indexOf(this.selected_event.title);
                if(index < (this.map_events.length - 1)) {
                    var previous_post_index = (index + 1);
                    return this.map_events[previous_post_index];
                } else {
                    return this.map_events[0];
                }
            }
            return false;
        },
        theme_set() {
            // Used by: Side panel
            // This is used for hiding the side panel AND toggle button

            if(this.theme.length > 0) {
                return true;
            }
            return false;
        }
    },
    watch: {
        fullscreen: {
            // Used by: Fullscreen button
            // Controls the class names on the header and footer
            handler(newValue) {
                // console.log('WATCH: fullscreen');
                var header = document.getElementById('site-header');
                var footer = document.getElementById('site-footer');
                if(newValue == true) {
                    header.classList.add("hidden");
                    footer.classList.add("hidden");
                } else {
                    header.classList.remove("hidden");
                    footer.classList.remove("hidden");
                }
            },
            deep: true
        },
        selected_event: {
            // Used by: Fullscreen button
            // Controls the class names on the header and footer
            handler() {
                // console.log('WATCH: selected_event');
                this.changing_event = true;
                this.audio.duration = 0;
                this.audio.remaining = 0;
                this.clear_audio_interval();  
                this.changing_event = false;     
                if(!this.audio.playing) {
                    this.audio_play();
                    this.audio_fade_in_and_out();
                }
            },
            deep: true
        }
    },
    methods: {
        // On initial load, set the map
        set_inital_map() {
            // console.log('METHOD: Set initial map');
            // Used on: Map first load

            this.holding_map = this.options.initial_map;
            var holding_map = document.getElementById('holding-map');
            if(holding_map !== null) {
                holding_map.classList.add("fade-in");
            }
        },
        // When you toggle between centuries and themes
        change_map_type(value) {
            // console.log('METHOD: Change map type');
            // Used by: Time Period / Theme toggle buttons
            // This removes all markers, display the holding map, and swaps over the background map

            // Hide the side panel
            this.side_panel = false;

            // Clear all markers on the map
            this.animate_out_theme_markers();
            this.animate_out_event_markers();
            
            // Show our holding map
            this.show_holding_map = true;

            // Transition our holding map
            if(value == 'themes') {            
                // Fade out holding map
                this.fade_holding_map = true;
                // Now hide off our holding map and reset our fade boolean
                this.show_holding_map = false;
                this.fade_holding_map = false;
            }
                
            // Update our holding map for next map change so it displays 
            if(value == 'time_periods') {
                this.holding_map = this.options.time_period_map;
            } else {
                this.holding_map = this.options.theme_map;
            }
            
            // Finally update out map type value
            this.type = value;
            
            if(value == 'themes') {
                this.theme = '';
                this.time_period = '';
            }

        },
        animate_out_event_markers() {  
            // console.log('METHOD: Animate out event markers');
            // Used by: Map change function and set current time period function
            // Applies a fade-out class name to each event marker
            
            // Localise the global scope
            const that = this;

            // Get all of our markers on the map
            var event_markers = document.getElementsByClassName('event-marker');
            
            // Loop through and apply our class name to each one
            for(var j = 0; j < event_markers.length; j++) {
                // console.log(event_markers[j]);
                // console.log(event_markers[j].classList);
                event_markers[j].classList.add("fade-out");
            }

            // Hide the side panel
            this.side_panel = false;

            // Clear out the selected event
            this.selected_event = null;
            
            // Clear out our map events array
            that.map_events = [];

        },
        animate_out_theme_markers() { 
            // console.log('METHOD: Animate out theme markers'); 
            // Used by: Map change function and set current theme function
            // Applies a fade-out class name to each theme marker

            // Localise the global scope
            const that = this;

            // Get all of our markers on the map
            var theme_markers = document.getElementsByClassName('theme-marker');

            // Loop through and apply our class name to each one
            for(var i = 0; i < theme_markers.length; i++) {
                theme_markers[i].classList.add("fade-out");
            }

            // Clear out our map themes array
            that.map_themes = [];
        },
        // Define the parent content we are looking at
        set_current_time_period(value) {
            // console.log('METHOD: Set current time period');
            // Used by: Time Period toggle button
            // Sets the time period and theme values, removes the existing markers, and loads in the new map and markers

            // Update our global time period variable
            this.time_period = value;

            // We hide the side panel since there is no theme or event selected, hence nothing to show
            this.side_panel = false;

            // If currenty viewing time periods clear out the theme value and hide the side panel
            // We don't want a theme selected by default
            if(this.type == 'time_periods') {
                this.theme = '';
            }

            // Now animate out event markers
            this.animate_out_event_markers();

            // And load our new map and markers
            this.load_background_map();
            this.load_themes_on_map();
        },
        set_current_theme(value) {
            // console.log('METHOD: Set current theme');
            // console.log(value);
            // Used by: Time Period theme marker pins and the individual Theme buttons
       
            // If displaying by theme we want to ensure there is no time period set, otherwise it will affect the filter results
            if(this.type == 'themes') {
                this.time_period = '';
            }
            
            // Update our central theme variable
            this.theme = value;

            // Finally load our events for the current theme
            this.load_events_on_map();
        },
        // Load map / content onto the map
        load_background_map() {
            // console.log('METHOD: Load background map');
            // Used by: Set current time period function
            // Changes the background map on change
            
            var new_time_period = this.time_periods.filter(e => e.slug === this.time_period);

            // Show holding map
            map_fade();

            // Load new map into main map variable
            let update_main_map = new Promise(resolve => {
                this.map = new_time_period[0].map;
            });
            let fade_out_holding_map = new Promise(resolve => {
                setTimeout(() => {
                    map_fade();
                }, 1000);
            });
            let update_holding_map = new Promise(resolve => {
                this.holding_map = new_time_period[0].map;
            });
            async function fetchAndLogResult() {
                let result = await Promise.race([update_main_map, fade_out_holding_map, update_holding_map]);
            }

            function map_fade() {
                var holding_map = document.getElementById('holding-map');
                if(holding_map.classList.contains('fade-in')) {
                    holding_map.classList.remove("fade-in");
                    holding_map.classList.add("fade-out");
                } else {
                    holding_map.classList.add("fade-in");
                    holding_map.classList.remove("fade-out");
                };
            }

        },
        load_events_on_map() {
            // console.log('METHOD: Load events on map');
            // Used by: Set current theme function
            // Updates our events array for the map to display the relevant markers and opens the side panel

            // Clear the events array
            this.map_events = [];

            if(this.type == 'time_periods') {
                // Loop through the events, find ones with a matching theme, and load into the array
                for(var i = 0; i < this.events.length; i++) {
                    if(this.events[i].time_periods[0] == this.time_period && this.events[i].themes.includes(this.theme)) {
                        this.map_events.push(this.events[i]);
                    }
                }
            } 
            if(this.type == 'themes') {
                for(var j = 0; j < this.events.length; j++) {
                    if(this.events[j].themes.includes(this.theme)) {
                        this.map_events.push(this.events[j]);
                    }
                }
            }

        },
        load_themes_on_map() {
            // console.log('METHOD: Load themes on map');
            // Used by: Change map type function and set current time period function
            // Updates our themes array for the map to display the relevant markers
            
            // Dump our themes into the map events array
            this.map_themes = this.themes;

            // When reloading our themes they can have the fade-out class still applied. Loop through and remove this class
            var theme_markers = document.getElementsByClassName('theme-marker');
            for(var i = 0; i < theme_markers.length; i++) {
                theme_markers[i].classList.remove("fade-out");
            }
        },
        // Shift the content around
        randomise_coordinates_array() {
            // console.log('METHOD: Randomise coordinates array');
            // Used by: Select random coordinates array
            // console.log(this.coordinates_array);

            if(this.type == 'time_periods') {
                // Pick one from the main array
                this.coordinates_array = this.time_period_marker_positions[Math.floor(Math.random() * this.time_period_marker_positions.length)];
            } else {
                this.coordinates_array = this.theme_marker_positions;
            }
            let coordinates = this.coordinates_array;

            // Now randomise the arrays inside
            let currentIndex = coordinates.length,  randomIndex;

            // While there remain elements to shuffle.
            while (currentIndex != 0) {

                // Pick a remaining element.
                randomIndex = Math.floor(Math.random() * currentIndex);
                currentIndex--;

                // And swap it with the current element.
                [coordinates[currentIndex], coordinates[randomIndex]] = [
                coordinates[randomIndex], coordinates[currentIndex]];
            }

            // Load this randomised array into our final for use on the markers.
            this.coordinates_array = coordinates;   

        },
        change_event(function_name) {
            // Promise
            // Call fade out
            // Then load the function delcared
        },
        // Display of indivdual events
        show_event_in_side_panel() {
            // console.log('METHOD: Show event in side panel');
            // Used by: Events markers

            // Show the side panel
            this.side_panel = true;

            // // Set the tab to show the event
            // this.side_panel_event = true;

            this.changing_event = false;
            
            this.audio_play();
            this.audio_fade_in_and_out();
        },
        //
        audio_current_time(current_time) {
            // console.log('METHOD: Audio current time');
            // Used by: Side panel
            // This returns a whole number

            if(Number.isInteger(current_time)) {
                this.audio.remaining = this.convert_seconds_to_pretty_format(current_time); 
            }
        },
        audio_fade_in_and_out() {
            // console.log('METHOD: Audio fade in and out');
            // Used by: Side panel
            // Also helps to set our duration and current values

            this.$nextTick(() => {

                // Clear any existing intervals
                this.clear_audio_interval();

                // Localise the global scope
                const that = this;

                // Load our audio element
                // var sound = this.$refs.wavsur.waveSurfer;
                var sound = this.$refs['audio'];

                // Reset the volume value
                // sound.volume = 0.0;

                // How much to add or remove from the audio volume everytime
                var increment = ((1 / this.options.fade_out_duration) / 4);
                
                // Localise our fade in / out time value
                var fade_length = this.options.fade_out_duration;

                // Set out audio duration variable
                this.audio.duration = '';

                // We cannot easily use the current time value, so we are building our own each iteration
                let current_time = 0;
                that.audio_current_time(0.25); // Cheeky workaround by making it start at 0.25s to ensure it counts to the whole number

                this.audio_interval = setInterval(audio_loop, 250); // Every 0.25 OR 1/4 second
                    
                function audio_loop() {

                    // If the audio is playing
                    if((sound.currentTime > 0) && (sound.currentTime <= sound.duration)) {

                        // console.log(sound.currentTime);

                        that.audio_total_time(sound.duration);

                        // This counts up as the audio is playing, thus giving us a current time
                        if(sound.duration > 0 && !sound.paused) {
                            current_time += 0.25;
                            that.audio_current_time(current_time);
                        }

                        // Fade in
                        // Is the current playing time within the first X seconds of the audio filev
                        // if ((sound.currentTime < fade_length) && (sound.volume < (1.0 - increment))) {
                        //     sound.volume += increment;
                        // }
                        
                        // Fade out
                        // Is the current playing time within the last X seconds of the audio file
                        if ((sound.currentTime >= (sound.duration - fade_length)) && (sound.volume > (0.0 + increment))) {
                            sound.volume -= increment;
                        }
                        
                        // Reset interval
                        if (sound.volume === 0.0 || sound.currentTime == sound.duration) {
                            if(that.audio_interval !== undefined) {
                                that.audio_pause(true);
                            }
                        }
                        
                    }

                };
                
            });
        },
		audio_pause(value) {
            // console.log('METHOD: Audio pause');
            // Used by: Audio loop function within audio_play

            // Change our boolean, for the play/pause buttons
            this.audio.playing = false;
            
            this.$nextTick(() => {
                if(value) {
                    // Clear the old interval, this ensure the current time value is cleared also
                    this.clear_audio_interval();
                }
                // Now stop the old audio
                if(this.$refs['audio']) {
                    this.$refs['audio'].pause();
                }
            });

        },
		audio_play() {
            // console.log('METHOD: Audio play');
            // Used by: Side panel

            // Change our boolean, for the play/pause buttons
            this.audio.playing = true;
            
            // Now play our audio
            this.$nextTick(() => {
                this.$refs['audio'].play();
            });
        },  
        audio_time(current_time) {
            var time = Math.floor(current_time);
            this.time = this.convert_seconds_to_pretty_format(time);
        },  
        audio_total_time(duration) {
            // console.log('METHOD: Audio total time');
            // Used by: Side panel
            // This returns a whole number

            var seconds = Math.round(duration);
            this.audio.duration = this.convert_seconds_to_pretty_format(seconds);
        },
        check_current_theme(value) {
            // console.log('METHOD: Check current theme');
            // console.log(value);
            // Used by: Theme markers to determine if they have events and to disable or not the button
            
            let disabled = true;

            if(this.type == 'time_periods') {
                for(var i = 0; i < this.events.length; i++) {
                    if(this.events[i].time_periods[0] == this.time_period && this.events[i].themes.includes(value)) {
                        disabled = false;
                    }
                }
            } 
            if(this.type == 'themes') {
                // console.log(this.events);
                for(var j = 0; j < this.events.length; j++) {
                    if(this.events[j].themes.includes(value)) {
                        disabled = false;
                    }
                }
            }

            return disabled;
        },
        clear_audio_interval() {
            // console.log('METHOD: Clear interval');
            clearInterval(this.audio_interval);
        },
        convert_seconds_to_pretty_format(duration) {
            // Hours, minutes and seconds
            var hrs = ~~(duration / 3600);
            var mins = ~~((duration % 3600) / 60);
            var secs = ~~duration % 60;

            // Output like "1:01" or "4:03:59" or "123:03:59"
            var ret = "";

            if (hrs > 0) {
                ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
            }

            ret += "" + mins + ":" + (secs < 10 ? "0" : "");
            ret += "" + secs;
            return ret;
        },
        // Background styling methods        
        marker_colour(value) {
            // console.log('METHOD: Marker colour');
            // console.log(value);
            // Used by: Map marker pins
            // This selects the appropriate colour hex from the theme object
            
            if(value.colour) {
                // console.log('1');
                return value.colour;
            } else {
                // console.log('2');
                var theme = this.themes.filter(e => e.slug === value.themes[0]);
                return theme[0].colour;
            }
        }, 
        set_active_button_class(item_value,set_value) {
            // console.log('METHOD: Set active button class');
            // Used by: Time Period and Theme buttons
            // This determine if the button is the current time period / theme and applies the appropriate class name

            if(item_value == set_value) {
                return 'active';
            }
            if(set_value.length > 0) {
                return 'not-active';
            }
            return false;
        },
        // Activity countdown / modal
        inactivity_body_class() {
            // console.log('METHOD: Inactivity body class');
            // Used by: Inactivity countdown and button

            var body = document.body;
            if(body.classList.contains('no-activity')) {
                body.classList.remove("no-activity");
            } else {
                body.classList.add("no-activity");
            };
        },
        inactivity_countdown() {
            // console.log('METHOD: Inactivity countdown');
            // Used by: The page to reload after X seconds

            var self = this;
            
            var interval = setInterval(function() {
                self.idle_time = self.idle_time + 10;
                // console.log(self.idle_time);
                if(self.idle_time >= self.inactivity_time) {
                    self.inactivity_body_class();
                    self.inactivity_notice = true;
                }
                if(self.idle_time == self.total_time) {
                    window.location = self.options.homepage;
                }
            }, 10000);

            // If the mouse is moved or a key pressed the idle timer resets
            addEventListener('mousemove', (event) => {});
            onmousemove = (event) => {
                // console.log('mousemove');
                self.idle_time = 0;
            };

            addEventListener('keydown', (event) => {});
            onkeydown = (event) => {
                // console.log('keydown');
                self.idle_time = 0;
            };

        },
    },
    created() {
        // This is used on the fullscreen template, where we pass a true value. This is for the interactive displays
        if(this.options.fullscreen == true) {
            this.fullscreen = true
        }
        // Load coordinates
        // console.log('CREATED: Randomise coordinates array');
        this.randomise_coordinates_array();
        // Now load the inital map
        // console.log('CREATED: Set inital map');
        this.set_inital_map();
        // Begin the inactivty countdown
        // console.log('CREATED: Begin inactivity countdown');
        this.inactivity_countdown();
    },
}

</script>